import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getHoneycombRailHexColour } from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const HoneycombVertical = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patternUrl = getPatternImages(state);
  var stackSide = state.context.custom.stackSide
    ? state.context.custom.stackSide
    : '';
  const railColour = state.context.custom.railColour
    ? state.context.custom.railColour
    : 'White';
  const railColourHex = getHoneycombRailHexColour(railColour);

  if (stackSide === '' || stackSide === 'Left') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 545 410"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="hcVertical"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>

        <path fill="url(#hcVertical)" d="M5.015 409.065v-409h251.5v409z" />
        <linearGradient
          id="hcVertical__a"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2629.407}
          x2={204.49}
          y2={2629.407}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#bbbcbe" />
          <stop offset={0.292} stopColor="#989ca0" />
          <stop offset={0.652} stopColor="#bfbec2" />
          <stop offset={0.865} stopColor="#9ea0a4" />
          <stop offset={1} stopColor="#a7a9ac" />
          <stop offset={1} stopColor="#c3c6ca" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M256.5 0v409h-5V0z" />
        <linearGradient
          id="hcVertical__b"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2377.927}
          x2={204.49}
          y2={2377.927}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#bbbcbe" />
          <stop offset={0.292} stopColor="#989ca0" />
          <stop offset={0.652} stopColor="#bfbec2" />
          <stop offset={0.865} stopColor="#9ea0a4" />
          <stop offset={1} stopColor="#a7a9ac" />
          <stop offset={1} stopColor="#c3c6ca" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M5 0v409H0V0z" />
        <linearGradient
          id="hcVertical__c"
          gradientUnits="userSpaceOnUse"
          x1={159.221}
          y1={-223.186}
          x2={713.435}
          y2={-223.186}
          gradientTransform="translate(-159.221 228.186)"
        >
          <stop offset={0.006} stopColor="#bbbcbe" />
          <stop offset={0.292} stopColor="#989ca0" />
          <stop offset={0.652} stopColor="#bfbec2" />
          <stop offset={0.865} stopColor="#9ea0a4" />
          <stop offset={1} stopColor="#a7a9ac" />
          <stop offset={1} stopColor="#c3c6ca" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M0 0h554.2v10H0z" />
        <linearGradient
          id="hcVertical__d"
          gradientUnits="userSpaceOnUse"
          x1={436.328}
          y1={-200.127}
          x2={436.328}
          y2={-218.186}
          gradientTransform="translate(-159.221 228.186)"
        >
          <stop offset={0.489} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <path fill="url(#hcVertical__d)" d="M0 10h554.2v18.1H0z" />
      </svg>
    );
  } else if (stackSide === 'Right') {
    return (
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 554.2 409"
        {...props}
      >
        <defs>
          <pattern
            id="hcVertical"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <path fill="url(#hcVertical)" d="M302.75 409.099v-409h251.5v409z" />
        <linearGradient
          id="prefix__a"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2927.141}
          x2={204.49}
          y2={2927.141}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M554.2 0v409h-5V0z" />
        <linearGradient
          id="prefix__b"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2675.662}
          x2={204.49}
          y2={2675.662}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M302.7 0v409h-5V0z" />
        <linearGradient
          id="prefix__c"
          gradientUnits="userSpaceOnUse"
          x1={159.221}
          y1={-223.186}
          x2={713.435}
          y2={-223.186}
          gradientTransform="translate(-159.221 228.186)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M0 0h554.2v10H0z" />
        <linearGradient
          id="prefix__d"
          gradientUnits="userSpaceOnUse"
          x1={436.328}
          y1={-200.127}
          x2={436.328}
          y2={-218.186}
          gradientTransform="translate(-159.221 228.186)"
        >
          <stop offset={0.489} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <path fill="url(#hcVertical__d)" d="M0 10h554.2v18.1H0z" />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 554.2 409"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="hcVertical"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <path
          fill="url(#hcVertical)"
          d="M5 409.05V.05h171.1v409zM380.664 409.013v-409h171.1v409z"
        />
        <linearGradient
          id="prefix__a"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2551.479}
          x2={204.49}
          y2={2551.479}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M178.6 0v409h-5V0z" />
        <linearGradient
          id="prefix__b"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2377.927}
          x2={204.49}
          y2={2377.927}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M5 0v409H0V0z" />
        <linearGradient
          id="prefix__c"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2927.141}
          x2={204.49}
          y2={2927.141}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M554.2 0v409h-5V0z" />
        <linearGradient
          id="prefix__d"
          gradientUnits="userSpaceOnUse"
          x1={-204.56}
          y1={2753.59}
          x2={204.49}
          y2={2753.59}
          gradientTransform="rotate(-90 -1085.469 1289.959)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={railColourHex} d="M380.7 0v409h-5V0z" />
        <linearGradient
          id="prefix__e"
          gradientUnits="userSpaceOnUse"
          x1={159.221}
          y1={-223.186}
          x2={713.435}
          y2={-223.186}
          gradientTransform="translate(-159.221 228.186)"
        >
          <stop offset={0.006} stopColor="#b7b8ba" />
          <stop offset={0.292} stopColor="#94989c" />
          <stop offset={0.652} stopColor="#bbbabe" />
          <stop offset={0.865} stopColor="#9a9ca0" />
          <stop offset={1} stopColor="#a3a5a8" />
          <stop offset={1} stopColor="#bfc2c6" />
        </linearGradient>
        <path fill={`${railColourHex}`} d="M0 0h554.2v10H0z" />
        <linearGradient
          id="prefix__f"
          gradientUnits="userSpaceOnUse"
          x1={436.328}
          y1={-200.127}
          x2={436.328}
          y2={-218.186}
          gradientTransform="translate(-159.221 228.186)"
        >
          <stop offset={0.489} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <path fill="url(#prefix__f)" d="M0 10h554.2v18.1H0z" />
      </svg>
    );
  }
};
